import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';

import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { patchDeactivatePreventiveTaskAssignee } from '../../../../actions/task-schedule/PreventiveTaskAssignee';

const DeactivatePreventiveTaskAssigneeButton = ({
  preventiveTaskAssigneeId,
  dispatchPatchDeactivatePreventiveTaskAssignee,
}) => {
  const [showModal, setShowModal] = React.useState(false);

  const onClickDeactivate = () =>
    dispatchPatchDeactivatePreventiveTaskAssignee(preventiveTaskAssigneeId);

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  return (
    <Fragment>
      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickDeactivate}
        onClickCancel={closeModal}
      />

      <Button color="danger" onClick={openModal}>
        Desactivar
      </Button>
    </Fragment>
  );
};

DeactivatePreventiveTaskAssigneeButton.propTypes = {
  preventiveTaskAssigneeId: PropTypes.number.isRequired,
  dispatchPatchDeactivatePreventiveTaskAssignee: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPatchDeactivatePreventiveTaskAssignee:
    patchDeactivatePreventiveTaskAssignee,
};

export default connect(
  null,
  mapDispatchToProps,
)(DeactivatePreventiveTaskAssigneeButton);
